angular.module('leanlaw').filter('zeros', function () {
  return function (items, includeZeros) {
    if (!items) return [];
    return includeZeros ? items : items.filter(i => i.balance);
  };
});